// extracted by mini-css-extract-plugin
export var changeIcon = "_5p-4";
export var container = "_5p-0";
export var divider = "_5p-7";
export var externalLinkIcon = "_5p-1";
export var green = "_5p-5";
export var helpCircleIcon = "_5p-3";
export var iconButton = "_5p-2";
export var red = "_5p-6";